import React from 'react'
import { colors } from '../styles/theme'

export default function Loader({ size = 80 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="animate-spin"
    >
      <path
        d="M40.666 0C51.2729 0 61.4455 4.2129 68.9467 11.7122C76.4478 19.2115 80.6633 29.383 80.6659 39.9899C80.6686 50.5969 76.4582 60.7705 68.9608 68.2736C61.4634 75.7766 51.2929 79.9946 40.686 79.9999C30.0791 80.0052 19.9043 75.7974 12.3994 68.3019C4.8945 60.8063 0.673982 50.6369 0.666027 40.0299C0.658072 29.423 4.86334 19.2473 12.357 11.7405C19.8506 4.23369 30.0191 0.0106269 40.626 2e-05M40.6324 6.40001C31.7226 6.40892 23.1811 9.95629 16.8864 16.262C10.5918 22.5677 7.05933 31.1153 7.06602 40.0251C7.0727 48.935 10.6179 57.4773 16.9221 63.7736C23.2262 70.0698 31.773 73.6044 40.6828 73.5999C49.5926 73.5954 58.1358 70.0523 64.4336 63.7498C70.7314 57.4473 74.2682 48.9014 74.2659 39.9916C74.2637 31.0817 70.7227 22.5376 64.4218 16.2382C58.1208 9.93882 49.5758 6.39999 40.666 6.39999"
        fill={colors['neutral-08']}
      />
      <path
        d="M40.666 0C50.6212 0 60.2187 3.7123 67.5828 10.4114C74.9468 17.1105 79.5481 26.3148 80.4875 36.2257C81.4268 46.1365 78.6367 56.0414 72.6624 64.0047C66.688 71.968 57.9589 77.4173 48.1809 79.2876C38.4029 81.158 28.2789 79.3149 19.7874 74.1186C11.2959 68.9223 5.04728 60.7463 2.26268 51.1884C-0.521908 41.6305 0.357686 31.3778 4.72956 22.4338C9.10144 13.4899 16.6514 6.4977 25.9039 2.82368L28.2658 8.77188C20.4937 11.8581 14.1518 17.7315 10.4794 25.2444C6.80702 32.7573 6.06816 41.3696 8.40721 49.3982C10.7463 57.4268 15.9951 64.2947 23.128 68.6596C30.2608 73.0245 38.765 74.5727 46.9785 73.0016C55.192 71.4305 62.5245 66.8531 67.5429 60.164C72.5614 53.4748 74.9051 45.1546 74.1161 36.8296C73.327 28.5045 69.4619 20.7728 63.2761 15.1455C57.0903 9.51832 49.0284 6.39999 40.666 6.39999V0Z"
        fill={colors['neutral-12']}
      />
    </svg>
  )
}
